import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { APP_SETTINGS } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { AnalyticsService } from '../../core/services/analytics/analytics.service';
import { AuthService } from '../../core/services/auth/auth.service';
import { SpinnerService } from '../../core/services/spinner/spinner.service';
import { UtilityService } from '../../core/services/utility/utility.service';
import { UserProfileService } from '../user-profile/user-profile.service';
import { LegacyService } from './legacy.service';
import { NgIf, NgFor } from '@angular/common';

@Component({
    selector: 'app-legacy',
    templateUrl: './legacy.component.html',
    styleUrls: ['./legacy.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, NgFor],
})
export class LegacyComponent implements OnInit, OnDestroy {

  public screenWidth: number;
  private subscription: ISubscription[];
  public legacyInfo: any;
  private username: string;

  constructor(
    private utilityService: UtilityService,
    private spinnerService: SpinnerService,
    private analyticsService: AnalyticsService,
    private userProfileService: UserProfileService,
    private authService: AuthService,
    private legacyService: LegacyService,
    private changeDetector: ChangeDetectorRef
  ) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() {
    APP_SETTINGS.currentPage = 'legacy';
    this.username = this.authService.getUserName();
    this.subscription = [];
    this.spinnerService.show('bmwSpinner');
    this.subscription.push(this.legacyService.getLegacyInformationAll().subscribe(value => {
      this.spinnerService.hide('bmwSpinner');
      this.legacyInfo = value;
      this.changeDetector.detectChanges();
    }));
  }

  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnDestroy(): void {
    this.subscription.forEach(s => s.unsubscribe());
  }

  saveToAnalytics(documentTitle) {
    //Analytics Call
    if (APP_SETTINGS.isAdmin === 'true') {
      this.analyticsService.trackClicksbyAdminUser('Legacy', documentTitle, this.username);
    }
    else {
      this.analyticsService.trackClicksByDocumentsContentTypeLineMake('Legacy', documentTitle);
    }
    if (APP_SETTINGS.isExternal === 'true') {
      this.userProfileService.getUsersInfoById(this.authService.getUserName()).subscribe(userData => {
        this.analyticsService.trackClicksByExternalContentType('Legacy', documentTitle, userData['address1'], userData['city'], userData['state'], userData['zipCode']);
      });
    }
    if (APP_SETTINGS.isDealer === 'true') {
      this.analyticsService.trackDealerContentTypeLocation('Legacy', documentTitle, APP_SETTINGS.centerID, APP_SETTINGS.locationCode, APP_SETTINGS.marketCode,
        APP_SETTINGS.marketDescription, APP_SETTINGS.regionCode, APP_SETTINGS.regionDescription)
    }
  }
}
